import React from 'react';

import FullLayout from '@/ui/layouts/FullLayout';
import PageHeader from '@/ui/molecules/PageHeader';
import Paginator from '@/ui/molecules/Paginator';
import PostGrid from '@/ui/organisms/PostGrid';
import { clickVisitPostPageLink } from '@/utils/analytics/log-event';

export type TagInfo = {
  slug: string;
  name: string;
  description: string;
  count: number;
};
export type ExcerptPost = {
  id: number;
  title: string;
  date: string;
  excerpt: string;
  imageUrl: string | null;
};

type Props = {
  title: string;
  popularPosts: ExcerptPost[];
  tagInfo: TagInfo;
  totalPage: number;
  currentPage: number;
  url: string;
};

const Component: React.FC<Props> = ({
  url,
  title,
  tagInfo,
  totalPage,
  currentPage,
  popularPosts,
}) => {
  return (
    <FullLayout isLessonCourseBanner>
      <div className="mb-5 w-full">
        <PageHeader caption={title} />

        <div>{tagInfo.description}</div>

        <div className="mb-8 mt-4 md:mb-12">
          <PostGrid
            posts={popularPosts}
            logEvent={() => clickVisitPostPageLink('excerpt_tag_posts_list')}
          />
        </div>
      </div>
      <Paginator totalPage={totalPage} currentPage={currentPage} url={url} />
    </FullLayout>
  );
};

export default Component;
